jQuery(function ($) {
  blockSlider();
  rwdMenu();
  inifFancybox();
  goTo();
  // productsMenu(); // Fix 19: wyłączone - duplikat handlera .show-sub konflikt z .productsToggle (linia ~1268)
  productGallery();
  productsNav();
  knowledge();
  downloads();
  loadMoreNews();
  careerNav();
  searchTabs();
  searchExpand();
  showContactForm();
  generatePdf();
  contactFormMore();

  function decodeElementId(value) {
    const id = String(value || "").replace(/^#/, "");

    try {
      return decodeURIComponent(id);
    } catch (e) {
      return id;
    }
  }

  function findElementById($root, value) {
    const id = decodeElementId(value);

    if (!id) return $();

    return $root.find("[id]").filter(function () {
      return decodeElementId(this.id) === id;
    }).first();
  }

  // =========================
  // Contact: RODO "więcej"
  // =========================
  function contactFormMore() {
    $(".show-more-rodo").on("click", function (event) {
      event.preventDefault();
      var rodo = $(this).attr("href");
      $(rodo).addClass("active");
      $(this).hide();
    });
  }

  // =========================
  // PDF generator (AJAX blob)
  // =========================
  // WYŁĄCZONE: obsługa przeniesiona do pdf-cache-manager/frontend.js
  // (check-first + stopImmediatePropagation eliminuje race condition)
  function generatePdf() {
    // noop - handled by frontend.js
  }

  // =========================
  // Toggle files + search + sort (downloads list)
  // =========================
  function initDownloadsSearchSort() {
    // Rozwijanie / zwijanie kategorii
    $(".toggle-files").on("click", function () {
      var targetId = $(this).data("target");
      findElementById($(this).closest(".downloads, .downloads-list"), targetId).slideToggle();
      $(this).toggleClass("active");
    });

    // Wyszukiwanie plików
    $("#search-files").on("keyup", function () {
      var searchValue = ($(this).val() || "").toLowerCase();

      $(".download-category").each(function () {
        var $category = $(this);
        var matches = 0;

        $category.find(".files-list .download-row").each(function () {
          var $row = $(this);

          var title = ($row.data("title") ? String($row.data("title")) : $row.text()).toLowerCase();

          if (title.includes(searchValue)) {
            $row.show();
            matches++;
          } else {
            $row.hide();
          }
        });

        if (matches > 0) {
          $category.show();
        } else {
          $category.hide();
        }
      });
    });

    // Sortowanie
    $("#sort").on("change", function () {
      var sortOrder = $(this).val();

      // sort kategorii
      var categories = $(".download-category").get();

      categories.sort(function (a, b) {
        var categoryA = $(a)
          .find("h2")
          .clone()
          .children()
          .remove()
          .end()
          .text()
          .trim()
          .toLowerCase();
        var categoryB = $(b)
          .find("h2")
          .clone()
          .children()
          .remove()
          .end()
          .text()
          .trim()
          .toLowerCase();

        return sortOrder === "a-z" ? categoryA.localeCompare(categoryB) : categoryB.localeCompare(categoryA);
      });

      $(".product-downloads__wrapper").append(categories);

      // sort plików w każdej kategorii
      $(".files-list").each(function () {
        var $list = $(this);
        var rows = $list.find("> .download-row").get();

        rows.sort(function (a, b) {
          var fileA = String($(a).data("title") || $(a).text()).toLowerCase();
          var fileB = String($(b).data("title") || $(b).text()).toLowerCase();

          return sortOrder === "a-z" ? fileA.localeCompare(fileB) : fileB.localeCompare(fileA);
        });

        $list.append(rows);
      });
    });

    // startowy sort
    if ($("#sort").length) $("#sort").trigger("change");
  }

  // odpal tylko jeśli elementy istnieją
  initDownloadsSearchSort();

  // =========================
  // Portfolio AJAX
  // =========================
  (function initPortfolio() {
    function getPortfolioFilters($root) {
      const strip = (v) => String(v || "").replace("term-", "");

      return {
        products_type: strip($root.find('[name="products-tyoe"]').val()),
        products_profiling: strip($root.find('[name="products-profiling"]').val()),
      };
    }

    function fetchPortfolioItems($root, termId) {
      const filters = getPortfolioFilters($root);

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        method: "POST",
        dataType: "json",
        data: {
          action: "fetch_portfolio_items",
          term_id: termId || 0,
          products_type: filters.products_type || 0,
          products_profiling: filters.products_profiling || 0,
        },
        beforeSend: function () {
          $root.find(".portfolio-list__wrapper").addClass("loading");
        },
        success: function (response) {
          const $wrapper = $root.find(".portfolio-list__wrapper");

          if (!response || !response.success || !response.data) {
            $wrapper.removeClass("loading").html("<p>Wystąpił błąd.</p>");
            return;
          }

          $wrapper.removeClass("loading").html(response.data.html || "");
        },
        error: function () {
          $root.find(".portfolio-list__wrapper").removeClass("loading").html("<p>Wystąpił błąd.</p>");
        },
      });
    }

    $(".portfolio").each(function () {
      const $root = $(this);

      $root
        .off("click.portfolioCategories")
        .on("click.portfolioCategories", ".portfolio-categories a", function (e) {
          e.preventDefault();

          const termId = String($(this).attr("href") || "").replace("#term-", "");

          $root.find(".portfolio-list__wrapper").attr("data-current-term-id", termId || "");
          $root.find(".portfolio-categories li").removeClass("active");
          $root.find(".portfolio-categories a").removeClass("active");
          $(this).addClass("active").closest("li").addClass("active");

          fetchPortfolioItems($root, termId);
        });

      $root
        .off("change.portfolioFilters")
        .on("change.portfolioFilters", "#filter-form select", function () {
          const termId = $root.find(".portfolio-list__wrapper").attr("data-current-term-id") || 0;
          fetchPortfolioItems($root, termId);
        });

      $root
        .off("click.portfolioReset")
        .on("click.portfolioReset", "#filter-form .reset", function (e) {
          e.preventDefault();

          $root.find("#filter-form select").val("");
          $root.find(".portfolio-list__wrapper").attr("data-current-term-id", "");
          $root.find(".portfolio-categories li").removeClass("active");
          $root.find(".portfolio-categories a").removeClass("active");

          fetchPortfolioItems($root, 0);
        });
    });
  })();

  // =========================
  // Show contact form
  // =========================
  function showContactForm() {
    $(".show-contact-form").on("click", function (e) {
      e.preventDefault();
      $(this).hide();
      $("#contact-form").slideDown(500);
    });
  }

  // =========================
  // Search expand
  // =========================
  function searchExpand() {
    $(".expand-results").on("click", function (e) {
      e.preventDefault();

      var targetClass = $(this).attr("href");
      var $targetElement = $(targetClass);
      $(this).toggleClass("active");

      if ($targetElement.length) {
        $targetElement.slideToggle(500);
      }
    });
  }

  // =========================
  // Search tabs
  // =========================
  function searchTabs() {
    $(".search-results__display nav a").on("click", function (event) {
      event.preventDefault();
      var href = $(this).attr("href");
      $(".search-results__display nav a").removeClass("active");
      $(this).addClass("active");
      $(".search-results__display .results").hide();
      $(".search-results__display .results" + href).show();
    });

    $(".search-results__display .go-to-tab").on("click", function (event) {
      event.preventDefault();
      var href = $(this).attr("href");
      $(".search-results__display nav a").removeClass("active");
      $('.search-results__display nav a[href="' + href + '"]').addClass("active");
      $(".search-results__display .results").hide();
      $(".search-results__display .results" + href).show();
    });
  }

  // =========================
  // Career nav
  // =========================
  function careerNav() {
    $(".apply-job").on("click", function (event) {
      event.preventDefault();
      const href = $(this).attr("data-pos");
      const career = href - 2;
      $('select[name=your-job] option').eq(career).prop("selected", true);
      $("html, body").animate(
        {
          scrollTop: $("#kariera").offset().top - 20,
        },
        500
      );
    });

    $(".contact-button a").on("click", function (event) {
      event.preventDefault();
      const href = $(this).attr("data-pos");
      const career = parseInt(href, 10) + 1;
      $('select[name=your-regio] option').eq(career).prop("selected", true);
    });

    $(".show-career").on("click", function (e) {
      e.preventDefault();

      const article = $(this).closest("article");

      if (article.hasClass("active")) {
        article.find(".career__description").slideUp();
        article.removeClass("active");
      } else {
        article.addClass("active");
        article.siblings("article").removeClass("active");
        article.find(".career__description").slideDown();
        article.siblings("article").find(".career__description").slideUp();
      }
    });
  }

  // =========================
  // Load more news
  // =========================
  function loadMoreNews() {
    $("#load-more-posts").off("click.loadMoreNews").on("click.loadMoreNews", function () {
      const button = $(this);
      const offset = parseInt(button.data("offset"), 10) || 0;
      const nonce = button.data("nonce");
      var btn_text = button.html();
      var no_more_news = $("#no-more-news").text();

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
          action: "load_more_posts",
          offset: offset,
          nonce: nonce,
        },
        beforeSend: function () {
          button.prop("disabled", true).text("...");
        },
        success: function (response) {
          if (response.success) {
            $(".fp-news__wrapper").append(response.data.html);
            button.data("offset", response.data.next_offset);

            if (response.data.has_more) {
              button.prop("disabled", false).html(btn_text);
            } else {
              button.text(no_more_news).prop("disabled", true);
            }
          } else {
            button.text(no_more_news).prop("disabled", true);
          }
        },
        error: function () {
          button.prop("disabled", false).html(btn_text);
        },
      });
    });
  }

  // =========================
  // Downloads section (knowledge/downloads accordion + ajax tree)
  // =========================
  function updateDivVisibility() {
    // Fix #28: guard - filtr dziala tylko na /do-pobrania/ (gdzie istnieje #select-downloads).
    // Bez tego ukrywa sekcje rowniez na /baza-wiedzy/ (selektor .right > div jest zbyt ogolny).
    if ($("#select-downloads").length === 0) return;

    $(".right > div").hide();

    $("#select-downloads input[type='checkbox']:checked").each(function () {
      var targetId = $(this).val();
      findElementById($(this).closest(".downloads"), targetId).show();
    });
  }

  updateDivVisibility();
  $("#select-downloads input[type='checkbox']").on("change", function () {
    updateDivVisibility();
  });

  function downloads() {
    $(".toggle-downloads").on("click", function () {
      var targetId = $(this).data("target");
      $(this).toggleClass("active");
      findElementById($(this).closest(".downloads"), targetId).children("article").slideToggle(300);
    });

    $("#downloads-form").on("submit", function (e) {
      e.preventDefault();

      const searchQuery = $("#search").val().toLowerCase();
      const $sections = $(".right > div");
      let found = false;

      $sections.each(function () {
        const $section = $(this);
        const $articles = $section.find("article");
        let sectionHasMatch = false;

        $articles.each(function () {
          const $article = $(this);
          const content = $article.text().toLowerCase();
          if (content.includes(searchQuery)) {
            $article.show();
            sectionHasMatch = true;
            found = true;
          } else {
            $article.hide();
          }
        });

        if (sectionHasMatch) {
          $section.show();
          $section.find("h2").show();
        } else {
          $section.hide();
          $section.find("h2").hide();
        }
      });

      if (!found) alert("Nie znaleziono pasujących wyników.");
    });

    const ajaxUrl = "/wp-admin/admin-ajax.php";

    // Poziom 1
    $(document).on("click", ".level-1", function (e) {
      e.preventDefault();

      const $this = $(this);
      const parentId = $this.data("post-id");
      const $parentArticle = $this.closest("article");
      const $level2Container = $parentArticle.find(".level-2-container");

      if ($level2Container.length > 0 && $level2Container.is(":visible")) {
        $level2Container.hide();
        $this.removeClass("active");
        return;
      }

      $(".level-1").removeClass("active");
      $this.addClass("active");

      if ($level2Container.length > 0) {
        $level2Container.show();
        return;
      }

      $.ajax({
        url: ajaxUrl,
        type: "POST",
        data: {
          action: "get_child_posts",
          parent_id: parentId,
        },
        success: function (response) {
          const data = JSON.parse(response);

          if (data.length === 0) {
            alert("Brak podstron.");
            return;
          }

          const $newLevel2Container = $('<div class="level-2-container" style="display: block"></div>');
          data.forEach(function (childPost) {
            $newLevel2Container.append(`
              <article>
                <a href="#" class="level-2" data-post-id="${childPost.id}">
                  ${childPost.title}
                </a>
              </article>
            `);
          });

          $parentArticle.append($newLevel2Container);
        },
      });
    });

    // Poziom 2
    $(document).on("click", ".level-2", function (e) {
      e.preventDefault();

      const $this = $(this);
      const parentId = $this.data("post-id");
      const $parentArticle = $this.closest("article");
      const $level3Container = $parentArticle.find(".level-3-container");

      if ($level3Container.length > 0 && $level3Container.is(":visible")) {
        $level3Container.hide();
        $this.removeClass("active");
        return;
      }

      $(".level-2").removeClass("active");
      $this.addClass("active");

      if ($level3Container.length > 0) {
        $level3Container.show();
        return;
      }

      $.ajax({
        url: ajaxUrl,
        type: "POST",
        data: {
          action: "get_child_posts",
          parent_id: parentId,
        },
        success: function (response) {
          const data = JSON.parse(response);

          if (data.length === 0) {
            alert("Brak plików.");
            return;
          }

          const $newLevel3Container = $('<div class="level-3-container" style="display: block"></div>');

          data.forEach(function (childPost) {
            $newLevel3Container.append(`
              <article>
                <a href="${childPost.file}" target="_blank" class="download-file">
                  ${(() => {
                    const ext = String(childPost.file || "").split(".").pop().toLowerCase();
                    let iconSVG = "";

                    if (ext === "pdf") {
                      iconSVG = `<span>
<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42.4946 11.9072L31.285 0.259359C31.1254 0.0936719 30.9052 0 30.6753 0H13.9682C12.0984 0 10.5773 1.52058 10.5773 3.38955V15.2308H3.80649C2.4076 15.2308 1.26953 16.3685 1.26953 17.7671V30.4638C1.26953 31.8623 2.4076 33 3.80649 33H10.5773V40.6164C10.5773 42.4821 12.0984 44 13.9682 44H39.3402C41.2099 44 42.7311 42.4829 42.7311 40.6183V12.494C42.7311 12.2752 42.6463 12.0649 42.4946 11.9072ZM30.885 2.2843L40.0871 11.8461H30.885V2.2843ZM3.80649 31.3077C3.34071 31.3077 2.9619 30.9292 2.9619 30.4638V17.7671C2.9619 17.3017 3.3408 16.9231 3.80649 16.9231H26.6557C27.1215 16.9231 27.5003 17.3017 27.5003 17.7671V30.4638C27.5003 30.9292 27.1214 31.3077 26.6557 31.3077H3.80649ZM41.0387 40.6183C41.0387 41.5498 40.2767 42.3077 39.3401 42.3077H13.9682C13.0315 42.3077 12.2695 41.5491 12.2695 40.6165V33H26.6557C28.0546 33 29.1927 31.8623 29.1927 30.4638V17.7671C29.1927 16.3685 28.0546 15.2308 26.6557 15.2308H12.2695V3.38955C12.2695 2.4536 13.0315 1.69228 13.9682 1.69228H29.1926V12.6923C29.1926 13.1596 29.5715 13.5384 30.0387 13.5384H41.0387V40.6183Z" fill="#EE2A25"/>
<path d="M11.3846 21.4768C11.1037 21.1115 10.755 20.8744 10.3385 20.7653C10.0675 20.6926 9.48577 20.6562 8.59331 20.6562H6.23828V27.9246H7.70584V25.1828H8.66275C9.32713 25.1828 9.83451 25.1481 10.1849 25.0787C10.4427 25.0225 10.6964 24.9077 10.9459 24.7341C11.1955 24.5606 11.4012 24.3217 11.5632 24.0177C11.7252 23.7136 11.8062 23.3384 11.8062 22.8923C11.8061 22.3138 11.6656 21.842 11.3846 21.4768ZM10.1278 23.4773C10.0171 23.6393 9.86424 23.7583 9.66916 23.8343C9.47409 23.9104 9.08745 23.9483 8.50901 23.9483H7.70584V21.8858H8.41482C8.94368 21.8858 9.29568 21.9023 9.47082 21.9354C9.70878 21.9784 9.90549 22.0858 10.0608 22.2577C10.2162 22.4296 10.2938 22.6478 10.2938 22.9121C10.2939 23.127 10.2385 23.3153 10.1278 23.4773Z" fill="#EE2A25"/>
<path d="M18.8612 22.6419C18.7026 22.1775 18.4711 21.785 18.1671 21.4644C17.863 21.1438 17.4977 20.9207 17.0714 20.795C16.7541 20.7025 16.293 20.6562 15.6881 20.6562H13.0059V27.9246H15.7675C16.3096 27.9246 16.7425 27.8734 17.0664 27.7708C17.4994 27.6321 17.8432 27.4387 18.0977 27.1908C18.4348 26.8635 18.6942 26.4355 18.8761 25.9067C19.0248 25.4736 19.0992 24.958 19.0992 24.3598C19.0992 23.6789 19.0199 23.1063 18.8612 22.6419ZM17.4333 25.6266C17.3341 25.9522 17.2061 26.1861 17.049 26.3281C16.892 26.4703 16.6946 26.5711 16.4566 26.6305C16.2748 26.6769 15.979 26.7 15.5691 26.7H14.4734V21.8858H15.1328C15.731 21.8858 16.1327 21.909 16.3376 21.9553C16.6119 22.0148 16.8383 22.1288 17.0168 22.2974C17.1953 22.466 17.3341 22.7006 17.4333 23.0014C17.5324 23.3022 17.582 23.7335 17.582 24.2954C17.582 24.8573 17.5324 25.301 17.4333 25.6266Z" fill="#EE2A25"/>
<path d="M25.3363 21.8858V20.6562H20.3535V27.9246H21.8211V24.8358H24.8554V23.6062H21.8211V21.8858H25.3363Z" fill="#EE2A25"/>
</svg></span>`;
                    } else if (ext === "zip") {
                      iconSVG = `<span>
<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M35.1289 38.2734H8.11586C5.42423 38.2734 3.23438 36.0836 3.23438 33.392V19.4062C3.23438 18.91 3.6367 18.5078 4.13281 18.5078C4.62893 18.5078 5.03125 18.91 5.03125 19.4062V33.392C5.03125 35.0928 6.41493 36.4766 8.11586 36.4766H35.1289C35.8721 36.4766 36.4766 35.872 36.4766 35.1289V24.3477C36.4766 23.6046 35.8721 23 35.1289 23H11.3204C10.8243 23 10.422 22.5978 10.422 22.1016C10.422 21.6054 10.8243 21.2031 11.3204 21.2031H35.1289C36.8628 21.2031 38.2734 22.6138 38.2734 24.3477V35.1289C38.2734 36.8628 36.8628 38.2734 35.1289 38.2734Z" fill="#EE2A25"/>
<path d="M11.3203 23H6.82812C4.84653 23 3.23438 21.3878 3.23438 19.4062C3.23438 17.4247 4.84653 15.8125 6.82812 15.8125H11.3203C11.8165 15.8125 12.2188 16.2147 12.2188 16.7109C12.2188 17.2071 11.8165 17.6094 11.3203 17.6094H6.82812C5.83733 17.6094 5.03125 18.4155 5.03125 19.4062C5.03125 20.397 5.83733 21.2031 6.82812 21.2031H11.3203C11.8165 21.2031 12.2188 21.6054 12.2188 22.1016C12.2188 22.5978 11.8165 23 11.3203 23Z" fill="#EE2A25"/>
<path d="M39.1719 44.5625H14.0156C12.034 44.5625 10.4219 42.9503 10.4219 40.9688V37.375C10.4219 36.8788 10.8242 36.4766 11.3203 36.4766C11.8165 36.4766 12.2188 36.8788 12.2188 37.375V40.9688C12.2188 41.9595 13.0248 42.7656 14.0156 42.7656H39.1719C40.1627 42.7656 40.9688 41.9595 40.9688 40.9688V9.89557L34.3075 3.23438H14.0156C13.0248 3.23438 12.2188 4.04045 12.2188 5.03125V22.1015C12.2188 22.5977 11.8165 22.9999 11.3203 22.9999C10.8242 22.9999 10.4219 22.5977 10.4219 22.1015V5.03125C10.4219 3.04966 12.034 1.4375 14.0156 1.4375H34.6797C34.918 1.4375 35.1464 1.5322 35.315 1.70065L42.5025 8.88815C42.6709 9.05661 42.7656 9.28517 42.7656 9.52344V40.9688C42.7656 42.9503 41.1535 44.5625 39.1719 44.5625Z" fill="#EE2A25"/>
<path d="M40.9688 10.4219H34.6797C34.1836 10.4219 33.7812 10.0196 33.7812 9.52344V3.23438C33.7812 2.73817 34.1836 2.33594 34.6797 2.33594C35.1758 2.33594 35.5781 2.73817 35.5781 3.23438V8.625H40.9688C41.4649 8.625 41.8672 9.02723 41.8672 9.52344C41.8672 10.0196 41.4649 10.4219 40.9688 10.4219Z" fill="#EE2A25"/>
<path d="M23 9.52344H15.8125C15.3163 9.52344 14.9141 9.12121 14.9141 8.625C14.9141 8.12879 15.3163 7.72656 15.8125 7.72656H23C23.4961 7.72656 23.8984 8.12879 23.8984 8.625C23.8984 9.12121 23.4961 9.52344 23 9.52344Z" fill="#EE2A25"/>
<path d="M30.1875 13.1172H15.8125C15.3163 13.1172 14.9141 12.715 14.9141 12.2188C14.9141 11.7225 15.3163 11.3203 15.8125 11.3203H30.1875C30.6836 11.3203 31.0859 11.7225 31.0859 12.2188C31.0859 12.715 30.6836 13.1172 30.1875 13.1172Z" fill="#EE2A25"/>
<path d="M30.1875 16.7109H15.8125C15.3163 16.7109 14.9141 16.3087 14.9141 15.8125C14.9141 15.3163 15.3163 14.9141 15.8125 14.9141H30.1875C30.6836 14.9141 31.0859 15.3163 31.0859 15.8125C31.0859 16.3087 30.6836 16.7109 30.1875 16.7109Z" fill="#EE2A25"/>
</svg></span>`;
                    } else {
                      iconSVG = `<span>
<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42.4946 11.9072L31.285 0.259359C31.1254 0.0936719 30.9052 0 30.6753 0H13.9682C12.0984 0 10.5773 1.52058 10.5773 3.38955V15.2308H3.80649C2.4076 15.2308 1.26953 16.3685 1.26953 17.7671V30.4638C1.26953 31.8623 2.4076 33 3.80649 33H10.5773V40.6164C10.5773 42.4821 12.0984 44 13.9682 44H39.3402C41.2099 44 42.7311 42.4829 42.7311 40.6183V12.494C42.7311 12.2752 42.6463 12.0649 42.4946 11.9072ZM30.885 2.2843L40.0871 11.8461H30.885V2.2843ZM3.80649 31.3077C3.34071 31.3077 2.9619 30.9292 2.9619 30.4638V17.7671C2.9619 17.3017 3.3408 16.9231 3.80649 16.9231H26.6557C27.1215 16.9231 27.5003 17.3017 27.5003 17.7671V30.4638C27.5003 30.9292 27.1214 31.3077 26.6557 31.3077H3.80649ZM41.0387 40.6183C41.0387 41.5498 40.2767 42.3077 39.3401 42.3077H13.9682C13.0315 42.3077 12.2695 41.5491 12.2695 40.6165V33H26.6557C28.0546 33 29.1927 31.8623 29.1927 30.4638V17.7671C29.1927 16.3685 28.0546 15.2308 26.6557 15.2308H12.2695V3.38955C12.2695 2.4536 13.0315 1.69228 13.9682 1.69228H29.1926V12.6923C29.1926 13.1596 29.5715 13.5384 30.0387 13.5384H41.0387V40.6183Z" fill="#EE2A25"/>
</svg></span>`;
                    }

                    return iconSVG;
                  })()}
                  ${childPost.title}

                  <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28 24.5V20.5C28 20.2348 27.8946 19.9804 27.7071 19.7929C27.5196 19.6054 27.2652 19.5 27 19.5C26.7348 19.5 26.4804 19.6054 26.2929 19.7929C26.1054 19.9804 26 20.2348 26 20.5V24.5C26 24.7652 25.8946 25.0196 25.7071 25.2071C25.5196 25.3946 25.2652 25.5 25 25.5H7C6.73478 25.5 6.48043 25.3946 6.29289 25.2071C6.10536 25.0196 6 24.7652 6 24.5V20.5C6 20.2348 5.89464 19.9804 5.70711 19.7929C5.51957 19.6054 5.26522 19.5 5 19.5C4.73478 19.5 4.48043 19.6054 4.29289 19.7929C4.10536 19.9804 4 20.2348 4 20.5V24.5C4 25.2956 4.31607 26.0587 4.87868 26.6213C5.44129 27.1839 6.20435 27.5 7 27.5H25C25.7956 27.5 26.5587 27.1839 27.1213 26.6213C27.6839 26.0587 28 25.2956 28 24.5ZM21.62 19.28L16.62 23.28C16.4435 23.4195 16.225 23.4954 16 23.4954C15.775 23.4954 15.5565 23.4195 15.38 23.28L10.38 19.28C10.1978 19.108 10.0868 18.8739 10.069 18.6241C10.0511 18.3742 10.1277 18.1267 10.2836 17.9306C10.4395 17.7344 10.6633 17.604 10.9108 17.565C11.1583 17.526 11.4114 17.5813 11.62 17.72L15 20.42V6.5C15 6.23478 15.1054 5.98043 15.2929 5.79289C15.4804 5.60536 15.7348 5.5 16 5.5C16.2652 5.5 16.5196 5.60536 16.7071 5.79289C16.8946 5.98043 17 6.23478 17 6.5V20.42L20.38 17.72C20.4807 17.6249 20.6 17.5518 20.7305 17.5053C20.8609 17.4588 20.9996 17.4399 21.1377 17.4497C21.2758 17.4596 21.4104 17.4981 21.5329 17.5626C21.6553 17.6272 21.7631 17.7166 21.8492 17.825C21.9354 17.9334 21.9981 18.0585 22.0334 18.1924C22.0687 18.3263 22.0758 18.466 22.0542 18.6028C22.0327 18.7396 21.983 18.8704 21.9082 18.987C21.8335 19.1036 21.7353 19.2033 21.62 19.28Z" fill="#EE2A25"/>
                  </svg>
                </a>
              </article>
            `);
          });

          $parentArticle.append($newLevel3Container);
        },
      });
    });
  }

  // =========================
  // Knowledge section
  // =========================
  function getKnowledgeHashId(hash) {
    return decodeElementId(hash);
  }

  function findKnowledgeTarget($root, hash) {
    return findElementById($root, hash);
  }

  function knowledge() {
    $(".knowledge").each(function () {
      const $knowledge = $(this);
      const $links = $knowledge.find(".knowledge__types a");
      const currentHash = window.location.hash;
      const currentHashId = getKnowledgeHashId(currentHash);
      const $hashLink = $links.filter(function () {
        return getKnowledgeHashId($(this).attr("href")) === currentHashId;
      });

      if (!$links.filter(".active").length) {
        $links.first().addClass("active");
      }

      const target = currentHashId && $hashLink.length
        ? currentHash
        : $links.filter(".active").first().attr("href");
      const $target = findKnowledgeTarget($knowledge, target);

      $knowledge.find(".right > div").hide();

      if ($target.length) {
        $target.show().children("article").show();
      } else {
        $knowledge.find(".right > div").first().show().children("article").show();
      }
    });

    $("#knowledge-form").on("submit", function (e) {
      e.preventDefault();

      const searchQuery = $("#search").val().toLowerCase();
      const $sections = $(".right > div");
      let found = false;

      $sections.each(function () {
        const $section = $(this);
        const $articles = $section.find("article");
        let sectionHasMatch = false;

        $articles.each(function () {
          const $article = $(this);
          const content = $article.text().toLowerCase();
          if (content.includes(searchQuery)) {
            $article.show();
            sectionHasMatch = true;
            found = true;
          } else {
            $article.hide();
          }
        });

        if (sectionHasMatch) {
          $section.show();
          $section.find("h2").show();
        } else {
          $section.hide();
          $section.find("h2").hide();
        }
      });

      if (!found) alert("Nie znaleziono pasujących wyników.");
    });

    $(document).on("click", ".knowledge__types a", function (e) {
      e.preventDefault();
      const $knowledge = $(this).closest(".knowledge");
      $knowledge.find(".knowledge__types a").removeClass("active");
      $(this).addClass("active");
      const target = $(this).attr("href");
      const $target = findKnowledgeTarget($knowledge, target);

      if ($target.length) {
        $knowledge.find(".right > div").hide();
        $target.show().children("article").show();
        window.location.hash = target;
      }
    });

    $(document).on("click", ".knowledge .right article > a", function (e) {
      e.preventDefault();

      const targetId = $(this).attr("href");
      const $targetDiv = findKnowledgeTarget($(this).closest(".knowledge"), targetId);

      if ($targetDiv.length) {
        // Fix #28.1: toggle - ponowne klikniecie aktywnego linku zamyka opis
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $targetDiv.hide();
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, "", window.location.pathname + window.location.search);
          }
          return;
        }

        $(".right article a").removeClass("active");
        $(this).addClass("active");

        $(".right .knowledge-description").not($targetDiv).hide();
        $targetDiv.show();

        if ($targetDiv.offset()) {
          $("html, body").animate(
            {
              scrollTop: $targetDiv.offset().top - 100,
            },
            300
          );
        }

        window.location.hash = targetId;
      }
    });

    // hash on load
    const currentHash = window.location.hash;
    if (currentHash) {
      const currentHashId = getKnowledgeHashId(currentHash);
      const $targetDiv = findKnowledgeTarget($(".knowledge"), currentHash);
      const $targetLink = $(".knowledge .right article > a").filter(function () {
        return getKnowledgeHashId($(this).attr("href")) === currentHashId;
      });

      if ($targetDiv.length) {
        $(".right > div > div").hide();
        $targetDiv.show();
      }

      if ($targetLink.length) {
        $(".right article a").removeClass("active");
        $targetLink.addClass("active");
      }

      if ($targetDiv.length && $targetDiv.offset()) {
        $("html, body").animate(
          {
            scrollTop: $targetDiv.offset().top - 100,
          },
          300
        );
      }
    }
  }

  // reset
  $(document).on("click", ".reset, .reset-filters-link", function (e) {
    e.preventDefault();
    location.reload();
  });

  // =========================
  // Products nav scroll
  // =========================
  function productsNav() {
    $(".products-nav a").on("click", function (event) {
      event.preventDefault();

      var targetId = $(this).attr("href");
      var targetElement = $(targetId);

      if (targetElement.length) {
        $("html, body").animate(
          {
            scrollTop: targetElement.offset().top - 100,
          },
          600
        );
      }
    });

    function updateActiveNav() {
      var scrollPosition = $(window).scrollTop();

      $(".products-nav a").each(function () {
        var targetId = $(this).attr("href");
        var targetElement = $(targetId);

        if (targetElement.length) {
          var elementTop = targetElement.offset().top;
          var elementBottom = elementTop + targetElement.outerHeight();

          if (scrollPosition >= elementTop - 200 && scrollPosition < elementBottom - 200) {
            $(".products-nav a").removeClass("active");
            $(this).addClass("active");
            return false;
          }
        }
      });
    }

    $(window).on("scroll", function () {
      updateActiveNav();
    });

    updateActiveNav();
  }

  // =========================
  // Product gallery thumbnails
  // =========================
  function productGallery() {
    function getProductGalleryItems($photos, currentSrc) {
      const items = [];
      const used = {};

      function addImage(src) {
        if (!src || used[src] || String(src).charAt(0) === "#") return;

        used[src] = true;
        items.push({
          src: src,
          thumb: src,
          type: "image",
        });
      }

      addImage(currentSrc);

      $photos.find(".gallery-lightbox-items a[data-gallery-src]").each(function () {
        addImage($(this).attr("href"));
      });

      return items;
    }

    $(document)
      .off("click.productGalleryOpen")
      .on("click.productGalleryOpen", ".photos .open-gallery", function (e) {
        const href = $(this).attr("href");

        if (!href || String(href).charAt(0) === "#") {
          return;
        }

        e.preventDefault();

        const items = getProductGalleryItems($(this).closest(".photos"), href);

        if (!items.length || typeof Fancybox === "undefined") {
          return;
        }

        Fancybox.show(items, {
          Thumbs: {
            type: "classic",
          },
          loop: true,
          touch: false,
          dragToClose: false,
          dragHandle: ".fancybox-handle",
        });
      });

    $(".thumbnails-slider a").on("click", function (e) {
      e.preventDefault();
      var newImageSrc = $(this).data("url");

      $(".photos .main").html('<a href="#" class="open-gallery"><img src=""></a>');
      $(".photos .main img").show();
      $(".photos .main img").attr("src", newImageSrc);
      $(".photos .main a").attr("href", newImageSrc);

      if ($(this).hasClass("d3")) {
        var newFileSrc = $(this).data("file");
        $(".photos").addClass("d3");
        $(".file-3d").attr("href", "#modal");
        $(".photos .main a").attr("data-fancybox", "");
        $(".photos .main a").attr("href", "#modal");
        $(".photos .main").append(
          '<div id="modal" class="product-3d-modal"><model-viewer class="product-3d-viewer" camera-controls ar ar-modes="webxr scene-viewer quick-look" camera-orbit="-30deg 80deg 2.5m" src="' +
            newFileSrc +
            '" alt="lock"></model-viewer></div>'
        );
      } else {
        $(".photos").removeClass("d3");
      }
    });
  }

  // =========================
  // Products menu left panel (only toggle, no ajax)
  // =========================
  function productsMenu() {
    $("a.show-sub").on("click", function (e) {
      e.preventDefault();
      const $this = $(this);
      const $subMenu = $this.next("ul");

      if ($subMenu.is(":visible")) {
        $subMenu.slideUp();
        $this.removeClass("active");
      } else {
        $subMenu.slideDown();
        $this.addClass("active");
      }
    });
  }

  // =========================
  // GoTo
  // =========================
  function goTo() {
    $(".go-to").on("click", function (event) {
      event.preventDefault();
      var href = $(this).attr("href");
      var pos = -100;
      $("html, body").animate(
        {
          scrollTop: $(href).offset().top + pos,
        },
        500
      );
    });
  }

  // =========================
  // Fancybox
  // =========================
  function inifFancybox() {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      loop: true,
      touch: false,
      dragToClose: false,
      dragHandle: ".fancybox-handle",

      afterClose: function () {
        var videos = document.querySelectorAll(".inline-movies");
        videos.forEach(function (video) {
          video.pause();
        });
      },
    });
  }

  // =========================
  // RWD menu
  // =========================
  function rwdMenu() {
    var windowWidth = $(document).width();

    $("#hamburger").on("click", function (event) {
      event.preventDefault();
      $(this).toggleClass("open");
      $(".site-header__navigation > ul").slideToggle(500);
      $(".site-header").toggleClass("menu-opened");
    });

    if (windowWidth < 1025) {
      $(".site-header__navigation .menu-item-has-children > a").on("click", function (event) {
        event.stopPropagation();
        $(this).parent("li").children("ul").slideToggle(300);
        $(this).parent("li").toggleClass("active");
      });

      $(".menu-item-has-children").on("click", function (event) {
        if (!$(event.target).is("a")) {
          event.stopPropagation();
          $(this).children("ul").slideToggle(300);
          $(this).toggleClass("active");
        }
      });
    }
  }

  // =========================
  // Header scroll (zostawiam 1 wersję)
  // =========================
  (function () {
    var previousScroll = 0;

    $(window).on("scroll", function () {
      var currentScroll = $(this).scrollTop();

      if (currentScroll > 80) {
        if (currentScroll > previousScroll) {
          $("header").addClass("fixed");
          $("header").addClass("scrolled");
          $("body").addClass("scrolled");
        } else {
          $("header").removeClass("fixed");
          $("body").removeClass("scrolled");
        }
        previousScroll = currentScroll;
      } else {
        $("header").removeClass("fixed");
        $("header").removeClass("scrolled");
        $("body").removeClass("scrolled");
      }
    });
  })();

  // =========================
  // Sliders
  // =========================
  function blockSlider() {
    $(".header-slider").owlCarousel({
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplaySpeed: 1700,
      slideSpeed: 1700,
      navSpeed: 1700,
      dotsSpeed: 1700,
      dots: true,
      singleItem: true,
      navText: [
        '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.5 44C47.5 45.933 45.933 47.5 44 47.5L2 47.5C1.17157 47.5 0.5 46.8284 0.5 46L0.500004 2C0.500004 1.17157 1.17158 0.499996 2 0.499996L44 0.5C45.933 0.5 47.5 2.06701 47.5 4L47.5 44Z" stroke="white"/><path d="M28.666 24L19.3327 24" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.666L19.3333 23.9993L24 19.3327" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H46C46.8284 0.5 47.5 1.17157 47.5 2V46C47.5 46.8284 46.8284 47.5 46 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z" stroke="white"/><path d="M19.334 24H28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.334L28.6667 24.0007L24 28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      ],
      autoplayHoverPause: true,
    });

    $(".fp-portfolio-slider").owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      items: 1,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplaySpeed: 1700,
      slideSpeed: 1700,
      navSpeed: 1700,
      dotsSpeed: 1700,
      dots: false,
      singleItem: true,
      navText: [
        '<svg width="43" height="83" viewBox="0 0 43 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42 1.5L2 41.5L42 81.5" stroke="#B3B3B3" stroke-width="2"/></svg>',
        '<svg width="43" height="83" viewBox="0 0 43 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L41 41.5L1 81.5" stroke="black" stroke-width="2"/></svg>',
      ],
      autoplayHoverPause: true,
      responsive: {
        0: { items: 2 },
        960: { items: 3 },
        1100: { items: 3 },
        1240: { items: 4 },
      },
    });

    $(".fp-procesing-slider").owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      items: 1,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplaySpeed: 1700,
      slideSpeed: 1700,
      navSpeed: 1700,
      dotsSpeed: 1700,
      dots: false,
      singleItem: true,
      navText: [
        '<svg width="43" height="83" viewBox="0 0 43 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42 1.5L2 41.5L42 81.5" stroke="#B3B3B3" stroke-width="2"/></svg>',
        '<svg width="43" height="83" viewBox="0 0 43 83" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L41 41.5L1 81.5" stroke="black" stroke-width="2"/></svg>',
      ],
      autoplayHoverPause: true,
      responsive: {
        0: { items: 2 },
        960: { items: 3 },
        1100: { items: 3 },
        1240: { items: 4 },
      },
    });

    $(".thumbnails-slider").owlCarousel({
      loop: false,
      margin: 12,
      nav: true,
      items: 1,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplaySpeed: 1700,
      slideSpeed: 1700,
      navSpeed: 1700,
      dotsSpeed: 1700,
      dots: false,
      singleItem: true,
      navText: [
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 15L7.5 10L12.5 5" stroke="#EF3732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 15L12.5 10L7.5 5" stroke="#EF3732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      ],
      autoplayHoverPause: true,
      responsive: {
        0: { items: 2 },
        960: { items: 3 },
        1100: { items: 3 },
        1240: { items: 4 },
      },
    });

    // sync carousel (Twoje)
    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 10;
    var syncedSecondary = true;

    sync1
      .owlCarousel({
        items: 1,
        slideSpeed: 3000,
        nav: true,
        autoplay: false,
        autoplayHoverPause: true,
        autoplaySpeed: 1400,
        dots: false,
        loop: true,
        navText: ["<", ">"],
        responsiveClass: true,
        responsive: {
          0: { item: 1, autoplay: false },
          600: { items: 1, autoplay: true },
        },
        responsiveRefreshRate: 200,
        navText: ["", ""],
      })
      .on("changed.owl.carousel", syncPosition);

    sync2
      .on("initialized.owl.carousel", function () {
        sync2.find(".owl-item").eq(0).addClass("current");
      })
      .owlCarousel({
        items: slidesPerPage,
        margin: 20,
        dots: true,
        nav: false,
        smartSpeed: 1000,
        slideSpeed: 1000,
        slideBy: slidesPerPage,
        responsiveRefreshRate: 100,
      })
      .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) current = count;
      if (current > count) current = 0;

      sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");

      var onscreen = sync2.find(".owl-item.active").length - 1;
      var start = sync2.find(".owl-item.active").first().index();
      var end = sync2.find(".owl-item.active").last().index();

      if (current > end) sync2.data("owl.carousel").to(current, 100, true);
      if (current < start) sync2.data("owl.carousel").to(current - onscreen, 100, true);
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        sync1.data("owl.carousel").to(number, 100, true);
      }
    }

    sync2.on("click", ".owl-item", function (e) {
      e.preventDefault();
      var number = $(this).index();
      sync1.data("owl.carousel").to(number, 300, true);
    });
  }
});

/**
 * ==========================================================
 * PRODUCTS (scoped per blok .products):
 * - działa na stronie z Gutenbergiem i na taxonomy
 * - filtry biorą termId z aktualnego bloku (data-current-term-id)
 * ==========================================================
 */
(function ($) {
  const AJAX_URL = "/wp-admin/admin-ajax.php";

  function trimSlashes(s) {
    return String(s || "").replace(/^\/+|\/+$/g, "");
  }
  function stripEmbeddedOrigins(p) {
    return String(p || "").replace(/\/https?:\/{1,2}[^/]+/gi, "");
  }
  function normalizePath(p) {
    p = String(p || "").trim();
    p = p.replace(/^(https?:)\/([^/])/i, "$1//$2");
    try {
      p = new URL(p, window.location.origin).pathname;
    } catch (e) {}
    p = stripEmbeddedOrigins(p);
    return trimSlashes(p.split("?")[0].split("#")[0]);
  }

  function normalizeBase(p) {
    if (!p) return "/produkty/";
    p = String(p).trim();
    try {
      p = new URL(p, window.location.origin).pathname;
    } catch (e) {}
    p = stripEmbeddedOrigins(p);
    if (!p.startsWith("/")) p = "/" + p;
    if (!p.endsWith("/")) p += "/";
    return p;
  }

  function getSelectedFiltersFrom($root) {
    const strip = (v) => String(v || "").replace("term-", "");
    return {
      products_type: strip($root.find("#products-tyoe").val()),
      products_core: strip($root.find("#products-core").val()),
      products_plate: strip($root.find("#products-plate").val()),
      products_profiling: strip($root.find("#products-profiling").val()),
      products_heat: strip($root.find("#products-heat").val()),
    };
  }

  function clearStoredProductFilters() {
    try {
      sessionStorage.removeItem("products_filters");
      sessionStorage.removeItem("products_termId");
    } catch (e) {}
  }

  function setProductsFiltersVisibility($root, show) {
    const $form = $root.find("#filter-form");

    if (!$form.length) return;

    if (show) {
      $form.stop(true, true).slideDown(150);
    } else {
      $form.find("select").val("");
      $form.stop(true, true).slideUp(150);
      clearStoredProductFilters();
    }
  }

  function fetchTermIdBySlugPath(path) {
    return $.ajax({
      url: AJAX_URL,
      method: "POST",
      dataType: "json",
      data: { action: "get_products_category_by_slug", slug: path },
    });
  }

  // działa jako:
  // fetchCategoryOrProducts($root, termId, opts)
  // ORAZ jako:
  // fetchCategoryOrProducts(termId, opts)  <-- to masz w PHP kickstart
  window.fetchCategoryOrProducts = function (a, b, c) {
    let $root, termId, opts;

    // wariant 1: ($root, termId, opts)
    if (a && (a.jquery || a instanceof jQuery)) {
      $root = a;
      termId = b || 0;
      opts = c || {};
    } else {
      // wariant 2: (termId, opts)
      termId = a || 0;
      opts = b || {};
      $root = jQuery(".products").first(); // fallback
    }

    if (!$root || !$root.length) return;

    const initial = !!opts.initial;
    const filters = opts.filters || {};

    console.log("[fetchCategoryOrProducts] termId:", termId, "initial:", initial, "filters:", filters);

    jQuery.ajax({
      url: "/wp-admin/admin-ajax.php",
      method: "POST",
      dataType: "json",
      data: {
        action: "fetch_category_or_products",
        term_id: termId || 0,
        is_initial: initial ? 1 : 0,

        // płasko - tak jak czyta PHP
        products_type: filters.products_type || 0,
        products_core: filters.products_core || 0,
        products_plate: filters.products_plate || 0,
        products_profiling: filters.products_profiling || 0,
        products_heat: filters.products_heat || 0,
      },
      beforeSend: function () {
        $root.find(".products-list__wrapper").addClass("loading");
      },
      success: function (response) {
        const $wrapper = $root.find(".products-list__wrapper");

        if (response && response.success && response.data) {
          const data = response.data;
          $wrapper.removeClass("loading").html(data.html || "");
          setProductsFiltersVisibility($root, data.show_filters !== false);

          if (data.header_title) {
            jQuery(".page-header__wrapper h1").html(data.header_title);
          }
          if (typeof data.header_description !== "undefined") {
            jQuery(".page-header__description").html(data.header_description || "");
          }
          if (data.breadcrumbs) {
            jQuery(".breadcrumbs-wrapper").html(data.breadcrumbs);
          }
          if (data.browser_title) {
            document.title = data.browser_title;
          }
          if (jQuery(window).width() < 1024) {
            jQuery("html, body").animate({ scrollTop: $wrapper.offset().top }, 500);
          }
        } else {
          $wrapper.removeClass("loading").html("<p>Wystąpił błąd.</p>");
        }

        // Fade-in po załadowaniu contentu
        setTimeout(function () {
          $wrapper.css("opacity", "1");
        }, 50);
      },
      error: function () {
        const $wrapper = $root.find(".products-list__wrapper");
        $wrapper.removeClass("loading").html("<p>Wystąpił błąd.</p>");
        $wrapper.css("opacity", "1");
      },
    });
  };

  function syncSidebar($root, termId) {
    const $sidebar = $root.find(".products-categories").first();
    if (!termId || !$sidebar.length) return;

    $sidebar.find("li").removeClass("active");
    $sidebar.find("a.show-sub").removeClass("active");

    // UWAGA: w HTML są DWA linki z tym samym href (#term-x): właściwy i .show-sub
    const $link = $sidebar.find(`a[href="#term-${termId}"][data-term-id]`).first();
    if (!$link.length) return;

    const $li = $link.closest("li").addClass("active");

    const $parentLi = $li.parent("ul").closest("li");
    if ($parentLi.length) {
      $parentLi.children("ul").stop(true, true).slideDown(200);
      $parentLi.children("a.show-sub").addClass("active");
      $parentLi.addClass("active");
    }

    if ($li.children("ul").length) {
      $li.children("ul").stop(true, true).slideDown(200);
      $li.children("a.show-sub").addClass("active");
    }
  }

  function buildUrlForPath(PRODUCTS_BASE, path) {
    let raw = normalizePath(path);
    const base = normalizePath(PRODUCTS_BASE);
    if (base && raw.indexOf(base + "/") === 0) {
      raw = normalizePath(raw.slice(base.length));
    } else if (base && raw === base) {
      raw = "";
    }
    return normalizeBase(raw ? PRODUCTS_BASE + raw + "/" : PRODUCTS_BASE);
  }

  function setCurrentTerm($root, termId, path, PRODUCTS_BASE) {
    $root.attr("data-current-term-id", termId ? String(termId) : "");
    if (typeof path === "string") {
      const nextUrl = buildUrlForPath(PRODUCTS_BASE, path);
      try {
        history.pushState({ termId: termId || null, path: path || "" }, "", nextUrl);
      } catch (e) {}
    }
  }

  function getCurrentTerm($root) {
    const v = $root.attr("data-current-term-id");
    return v ? String(v) : null;
  }
  function getSelectedFiltersFromForm($form) {
  const strip = (v) => String(v || "").replace("term-", "");
  return {
    products_type: strip($form.find('[name="products-tyoe"]').val()),
    products_core: strip($form.find('[name="products-core"]').val()),
    products_plate: strip($form.find('[name="products-plate"]').val()),
    products_profiling: strip($form.find('[name="products-profiling"]').val()),
    products_heat: strip($form.find('[name="products-heat"]').val()),
  };
}
  // ==========================================
  // INIT per blok .products
  // ==========================================
  function initProductsBlock($root) {
    const $wrapper = $root.find(".products-list__wrapper").first();
    const PRODUCTS_BASE = normalizeBase($wrapper.data("productsBase") || "/produkty/");
    const initialTermId = parseInt($root.attr("data-current-term-id"), 10) || 0;

    // start: jeśli jesteśmy na /produkty/{slug}/, dociągnij termId z URL
    const pathname = window.location.pathname || "/";
const isUnderBase = pathname.indexOf(PRODUCTS_BASE) === 0;

// tylko jeśli jesteśmy pod /produkty/
const relPath = isUnderBase ? normalizePath(pathname.replace(PRODUCTS_BASE, "")) : "";

if (initialTermId) {
  syncSidebar($root, initialTermId);
  fetchCategoryOrProducts($root, initialTermId);
} else if (relPath) {
  fetchTermIdBySlugPath(relPath).done(function (termId) {
    if (!termId) return;
    $root.attr("data-current-term-id", String(termId));
    syncSidebar($root, termId);
    fetchCategoryOrProducts($root, termId);
  });
} else {
  // Przywróć filtry z sessionStorage (po hard refresh)
  let savedFilters = null;
  let savedTermId = null;
  try {
    const savedFiltersJson = sessionStorage.getItem('products_filters');
    const savedTermIdStr = sessionStorage.getItem('products_termId');
    if (savedFiltersJson) {
      savedFilters = JSON.parse(savedFiltersJson);
    }
    if (savedTermIdStr) {
      savedTermId = parseInt(savedTermIdStr) || 0;
    }
  } catch(e) {}

  // Jeśli są zapisane filtry, przywróć je w selectach
  if (savedFilters && Object.keys(savedFilters).some(k => savedFilters[k])) {
    const $form = $root.find("#filter-form");

    // ZACHOWAJ opacity: 0 (zostanie ustawione na 1 w AJAX success)
    // $root.find(".products-list__wrapper") pozostaje ukryty

    // Ustaw wartości w selectach
    if (savedFilters.products_type) $form.find('[name="products-tyoe"]').val('term-' + savedFilters.products_type);
    if (savedFilters.products_core) $form.find('[name="products-core"]').val('term-' + savedFilters.products_core);
    if (savedFilters.products_plate) $form.find('[name="products-plate"]').val('term-' + savedFilters.products_plate);
    if (savedFilters.products_profiling) $form.find('[name="products-profiling"]').val('term-' + savedFilters.products_profiling);
    if (savedFilters.products_heat) $form.find('[name="products-heat"]').val('term-' + savedFilters.products_heat);

    // Wywołaj fetch z zapisanymi filtrami
    const termId = savedTermId !== null ? savedTermId : 0;
    if (termId) {
      $root.attr("data-current-term-id", String(termId));
    }
    fetchCategoryOrProducts($root, termId, { initial: false, filters: savedFilters });
  } else {
    // Brak filtrów - pokaż kategorie (initial) i od razu fade-in
    fetchCategoryOrProducts($root, null, { initial: true });
  }
}


    // klik w LEWE MENU
    $root
      .off("click.productsLeft")
      .on("click.productsLeft", ".products-categories a[href^='#term-']:not(.show-sub)", function (e) {
        e.preventDefault();

        const termId = $(this).data("termId");
        const path = normalizePath($(this).data("slug") || "");

        if (!termId) return;

        setCurrentTerm($root, termId, path, PRODUCTS_BASE);
        syncSidebar($root, termId);

        // reset selectów przy zmianie kategorii
        $root.find("#filter-form select").val("");
        clearStoredProductFilters();

        fetchCategoryOrProducts($root, termId);
      });

    // toggle strzałki
    $root
      .off("click.productsToggle")
      .on("click.productsToggle", ".products-categories a.show-sub", function (e) {
        e.preventDefault();
        const $li = $(this).closest("li");
        const $sub = $li.children("ul");
        const open = $sub.is(":visible");

        if (open) {
          $sub.stop(true, true).slideUp(200);
          $(this).removeClass("active");
          $li.removeClass("active");
        } else {
          $sub.stop(true, true).slideDown(200);
          $(this).addClass("active");
          $li.addClass("active");
        }
      });

    // klik w KAFLE po prawej
    $root
      .off("click.productsCards")
      .on("click.productsCards", ".products-list__wrapper .category-link", function (e) {
        e.preventDefault();

        const termId = $(this).data("termId");
        const path = normalizePath($(this).data("slug") || "");

        if (!termId) return;

        setCurrentTerm($root, termId, path, PRODUCTS_BASE);
        syncSidebar($root, termId);

        // reset selectów przy zmianie kategorii
        $root.find("#filter-form select").val("");
        clearStoredProductFilters();

        fetchCategoryOrProducts($root, termId);
      });

    // FILTRY (change)
    $root
  .off("change.productsFilters")
  .on("change.productsFilters", "#filter-form select", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const $form = $(this).closest("form");
    let termId = getCurrentTerm($root);

    // Jeśli brak termId (strona główna), ustaw jako 0 ale NIE resetuj kategorii
    if (!termId) {
      termId = 0;
      // Ustaw data-current-term-id na "filtered" żeby zaznaczyć że filtrujemy
      $root.attr("data-current-term-id", "filtered");
    }

    const filters = getSelectedFiltersFromForm($form);

    // Zapisz filtry w sessionStorage (zachowane po refresh)
    try {
      sessionStorage.setItem('products_filters', JSON.stringify(filters));
      sessionStorage.setItem('products_termId', String(termId));
    } catch(e) {}

    fetchCategoryOrProducts($root, termId, { initial: false, filters });
  });

    // Reset w tym bloku (AJAX), bez reload
    $root
      .off("click.productsReset")
      .on("click.productsReset", "#filter-form .reset, .reset-filters-link", function (e) {
        e.preventDefault();
        $root.find("#filter-form select").val("");
        $root.attr("data-current-term-id", "");

        clearStoredProductFilters();

        try {
          history.pushState({ termId: null, path: "" }, "", PRODUCTS_BASE);
        } catch (e2) {}

        fetchCategoryOrProducts($root, null, { initial: true });
        $root.find(".products-categories li").removeClass("active");
        $root.find(".products-categories a.show-sub").removeClass("active");
      });
  }

  // init dla każdego bloku .products na stronie
  $(function () {
    $(".products").each(function () {
      initProductsBlock($(this));
    });
  });
})(jQuery);
